import axios from 'axios'
import router from '@/router'
// create an axios instance
const service = axios.create({
        baseURL: process.env.KIPAKI_BASE_URL,
        timeout: 590000
    })
    // request interceptor
service.interceptors.request.use(config => {
    serverBus.$emit('loader', true);
    config.headers.common['X-localization'] = localStorage.getItem('lang') || process.env.KIPAKI_locale;
    config.headers.common['X-Requested-With'] = 'XMLHttpRequest';
    config.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('auth_token');
    return config
}, error => {
    console.log(error) // for debug
    Promise.reject(error)
})

// respone interceptor
service.interceptors.response.use(
    response => {
        serverBus.$emit('loader', false);
        return response;
    },
    error => {
        serverBus.$emit('loader', false);
        if (error.response.status === 401) {
            return axios.post(process.env.KIPAKI_BASE_URL + 'auth/logout').then(response => {
                localStorage.removeItem('auth_token')
                router.push({ name: 'Login' })
            })
        }
        console.log('err' + error)
        return Promise.reject(error)
    })
export default service


// WEBPACK FOOTER //
// ./src/services/request.js